import { createFileRoute, Link, useNavigate } from "@tanstack/react-router"
import { ArrowLeft, ListChecks } from "lucide-react"
import { useState } from "react"
import { useTranslation } from "react-i18next"
import { PageContainer, PageHeader } from "@/components/app/page"
import { ErrorState } from "@/components/app/states"
import { Button } from "@/components/ui/button"
import { TaskDetailView } from "@/features/tasks/task-detail"
import { useTaskBoardEvents } from "@/features/tasks/use-task-events"

export const Route = createFileRoute("/_app/tasks/$taskId")({
  staticData: { titleKey: "tasks.task.detailTitle" },
  component: TaskPage,
})

function TaskPage() {
  const { t } = useTranslation()
  const { taskId } = Route.useParams()
  const navigate = useNavigate()
  const [title, setTitle] = useState<string>()
  useTaskBoardEvents()
  const id = Number(taskId)
  const back = (
    <Button variant="outline" size="sm" nativeButton={false} render={<Link to="/tasks" search={{}} />}>
      <ArrowLeft />
      {t("tasks.task.backToList")}
    </Button>
  )
  return (
    <PageContainer width="wide">
      <PageHeader
        icon={ListChecks}
        title={t("tasks.task.detailTitle")}
        documentTitle={title ?? t("tasks.task.detailTitle")}
        actions={back}
        className="mb-4 lg:mb-6"
      />
      {Number.isInteger(id) && id > 0 ? (
        <TaskDetailView
          key={id}
          taskId={id}
          onLoaded={(d) => setTitle(d.title)}
          onOpenTask={(next) => void navigate({ to: "/tasks/$taskId", params: { taskId: String(next) } })}
          onDeleted={() => void navigate({ to: "/tasks" })}
        />
      ) : (
        <ErrorState title={t("tasks.task.notFound")} />
      )}
    </PageContainer>
  )
}
